import React from 'react';
import { connect } from 'react-redux';
import {
  AppBar,
  Toolbar,
  Chip,
  Divider,
  Box,
  Grid,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  CssBaseline,
  Container,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import {
  Email,
  CalendarToday,
  Fingerprint,
  AssignmentInd,
} from '@material-ui/icons';
import { PAGE_ACTIONS, USER_ROLES } from 'Utils/constants';
import { getStatusStyle } from 'Utils/utils';
import { setUserCurrentAction } from 'Actions/users';
import { getUserInfo } from 'Actions/userViews';
import UserProfile from 'Components/content/profile';
import Header from 'Components/content/heading';
import moment from 'moment';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  avatar: {
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    backgroundColor: '#e5e8ee',
  },
  icon: {
    fontSize: 18,
    color: 'black',
  },
  item: {
    padding: 0,
  },
  itemIcon: {
    minWidth: '40px',
  },
  container: {
    padding: '0 8px 0 24px',
    height: '90vh',
    overflow: 'scroll',
  },
  profileAvatar: {
    borderRadius: 12,
    fontSize: '14px',
    color: '#fff',
    background: 'linear-gradient(315deg, #00cdcd, #009e9f)',
  },
  appBar: {
    backgroundColor: '#ffffff',
  },
  button: {
    marginTop: theme.spacing(18),
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(5),
    flexGrow: 'flex',
    width: '100%',
    color: 'inherit',
  },
});

class UserDetails extends React.Component {
  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
  }

  componentDidMount() {
    const { userId } = this.props;
    this.props.getUserInfo(userId);
  }

  componentDidUpdate(prevProps) {
    const { userId } = this.props;
    if (prevProps.userId !== userId) {
      this.props.getUserInfo(userId);
    }
  }

  handleEdit() {
    this.props.setUserCurrentAction(PAGE_ACTIONS.EDIT);
  }

  render() {
    const {
      name,
      designation,
      classes,
      email,
      access,
      createdAt,
      status,
      employeesCount,
    } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <AppBar position="static" elevation={0} className={classes.appBar}>
          <Toolbar variant="dense">
            <Typography variant="body2" color="textSecondary">
              USER DETAILS
            </Typography>
            <div className={classes.root} />
            <Chip
              label={status}
              size="small"
              className={getStatusStyle(status)}
            />
          </Toolbar>
          <Divider />
        </AppBar>
        <Container className={classes.container}>
          <Grid container direction="column">
            <Grid item>
              <UserProfile
                name={name}
                designation={designation}
                handleEdit={this.handleEdit}
                enableEdit
              />
            </Grid>
            <Grid item>
              <Box mb={2}>
                <Header value={'BASIC INFORMATION'} />
              </Box>
              <List disablePadding>
                <ListItem className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Avatar className={classes.avatar}>
                      <Fingerprint className={classes.icon} />
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText primary={'Access Type :'} id="accessType" />
                  <ListItemSecondaryAction>
                    <Typography variant="body2" color="textSecondary">
                      {access === USER_ROLES.HR_ADMIN
                        ? 'HR Admin'
                        : 'HR Partner'}
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Avatar className={classes.avatar}>
                      <Email className={classes.icon} />
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText primary={'Email Id :'} id="email" />
                  <ListItemSecondaryAction>
                    <Typography variant="body2" color="textSecondary">
                      {email}
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </Grid>
            <Grid item>
              <Box mt={2} mb={2}>
                <Header value={'OTHER DETAILS'} />
              </Box>
              <List disablePadding>
                <ListItem className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Avatar className={classes.avatar}>
                      <CalendarToday className={classes.icon} />
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText primary={'Date Added:'} />
                  <ListItemSecondaryAction>
                    <Typography variant="body2" color="textSecondary">
                      {createdAt
                        ? moment(createdAt).format('DD MMMM YYYY')
                        : null}
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
                {/* <ListItem className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Avatar className={classes.avatar}>
                      <Visibility className={classes.icon} />
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText primary={'Status:'} />
                  <ListItemSecondaryAction>
                    <Typography variant="body2" color="textSecondary">
                      Not Joined
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem> */}
                <ListItem className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Avatar className={classes.avatar}>
                      <AssignmentInd className={classes.icon} />
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText primary={'Total Employees Added:'} />
                  <ListItemSecondaryAction>
                    <Typography variant="body2" color="textSecondary">
                      {employeesCount} Employees
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </Container>
      </React.Fragment>
    );
  }
}

UserDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  designation: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  access: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  employeesCount: PropTypes.number.isRequired,
  setUserCurrentAction: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
};

const mapDispatchToProps = { setUserCurrentAction, getUserInfo };

const mapStateToProps = state => {
  return {
    ...state.userViews,
    userId: state.users.currentSelection,
  };
};

UserDetails = compose(withStyles(styles, { withTheme: true }))(UserDetails);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDetails);
